module.exports = __webpack_public_path__ + "img/@wisatagresik.875a0022.png";